import type { DropTarget } from './folderExplorerModel';

/**
 * W-09b: a drag of FILES from the computer (upload) versus an internal drag (move a file / folder).
 * An internal drag sets `internalActive` (the explorer's dragRef); a drag from the computer carries 'Files'.
 */
export function isFileDrag(types: ArrayLike<string> | null | undefined, internalActive: boolean): boolean {
  if (internalActive || !types) return false;
  return Array.from(types).includes('Files');
}

/**
 * D-308 (QX-1319): the explorer's write actions (upload, file drop, new folder, rename, move, delete) are shown
 * only when the caller may write the open customer's documents (server: GET /documents/write-access).
 * No customer open yet: the caller's own prop decides (nothing to write into anyway). An open lead's tree keeps
 * its own rule (the lead's visibility). Until the server answers: hidden.
 */
export function explorerCanWrite(canWriteProp: boolean, orgId: string, serverCanWrite: boolean | undefined): boolean {
  if (!canWriteProp) return false;
  if (!orgId || orgId.startsWith('lead:')) return canWriteProp;
  return serverCanWrite === true;
}

/** Whether this explorer accepts a file drop at all (write access and an open customer / lead). */
export function acceptsFileDrop(canWrite: boolean, orgId: string, fileDrag: boolean): boolean {
  return canWrite && !!orgId && fileDrag;
}

/**
 * Where dropped files go. The files area uploads to the open folder; a folder in the tree / table / breadcrumb
 * uploads to THAT folder (a customer / "all documents" node = that customer's top level).
 */
export function uploadTargetFor(
  where: { kind: 'area'; organizationId: string; folderId: string | null } | { kind: 'target'; target: DropTarget },
): DropTarget {
  return where.kind === 'area'
    ? { organizationId: where.organizationId, folderId: where.folderId }
    : { organizationId: where.target.organizationId, folderId: where.target.folderId };
}
